"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSpreedlyToken = exports.unpackSpreedlyResponse = exports.buildCreatePaymentMethodResult = exports.collapseClientErrors = exports.buildCreatePaymentMethodPayload = exports.buildDonationResult = exports.buildCashPaymentPayload = void 0;
var types_1 = require("./types");
function buildCashPaymentPayload(organizationId, input) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var billingAddress = {
        country: input.billingAddress.country,
        address1: input.billingAddress.address1,
        address2: input.billingAddress.address2,
        city: input.billingAddress.city,
        state: input.billingAddress.state,
        zip_code: input.billingAddress.zip,
    };
    var billingContact = {
        title: input.billingContact.salutation,
        first_name: input.billingContact.firstName,
        middle_name: input.billingContact.middleName,
        last_name: input.billingContact.lastName,
        company_name: input.billingContact.company,
        email: input.billingContact.email,
        home_phone: input.billingContact.primaryPhone,
        timezone: new Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    var payment = {
        payment_method_id: input.paymentMethodId,
        gateway_id: input.paymentGatewayId,
        amount: input.paymentAmount,
        type: 'cash',
        frequency: input.recurringFrequency,
        start_date: input.recurringStart,
        end_date: input.recurringEnd,
        retain_on_success: input.retainPaymentMethod,
    };
    var donationOptions = {
        organization_id: organizationId,
        campaign_id: input.campaignId,
        reference_code: input.referenceCode,
        double_the_donation_company_id: input.corporateMatchingId,
        donor_id: input.donorId,
        hide_name: input.anonymousOptIn,
        show_name_to_fundraiser: input.showNameToFundraiserOptIn,
        email_opt_in: input.emailOptIn,
        donor_paid_fee: input.donorPaidFeeAmount,
        designation_note: input.designationNote,
        gift_id: input.giftId,
        gift_extra: input.giftExtra,
        gift_skipped: input.giftSkipped,
        p2p_fundraiser_id: input.p2pFundraiserId,
        p2p_fundraiser_comment: input.p2pFundraiserComment,
        organization_event_id: input.organizationEventId,
        advocate_id: input.advocateId,
        advocacy_program_id: input.advocacyProgramId,
        advocacy_team_id: input.advocacyTeamId,
        page_id: input.landingPageId,
        embed_id: input.embedId,
        tribute_definition_id: (_a = input.tribute) === null || _a === void 0 ? void 0 : _a.tributeDefinitionId,
        tribute_first_name: (_b = input.tribute) === null || _b === void 0 ? void 0 : _b.tributeFirstName,
        tribute_last_name: (_c = input.tribute) === null || _c === void 0 ? void 0 : _c.tributeLastName,
        tribute_address1: (_d = input.tribute) === null || _d === void 0 ? void 0 : _d.tributeAddress1,
        tribute_address2: (_e = input.tribute) === null || _e === void 0 ? void 0 : _e.tributeAddress2,
        tribute_city: (_f = input.tribute) === null || _f === void 0 ? void 0 : _f.tributeCity,
        tribute_state: (_g = input.tribute) === null || _g === void 0 ? void 0 : _g.tributeState,
        tribute_postal_code: (_h = input.tribute) === null || _h === void 0 ? void 0 : _h.tributePostalCode,
        tribute_country: (_j = input.tribute) === null || _j === void 0 ? void 0 : _j.tributeCountry,
        tribute_from_name: (_k = input.tribute) === null || _k === void 0 ? void 0 : _k.tributeFromName,
        tribute_recipient_email: (_l = input.tribute) === null || _l === void 0 ? void 0 : _l.tributeRecipientEmail,
        honorees: (_m = input.tribute) === null || _m === void 0 ? void 0 : _m.honorees,
        tribute_send_card: (_o = input.tribute) === null || _o === void 0 ? void 0 : _o.tributeSendCard,
        tribute_include_amount: (_p = input.tribute) === null || _p === void 0 ? void 0 : _p.tributeIncludeAmount,
        tribute_skipped: (_q = input.tribute) === null || _q === void 0 ? void 0 : _q.tributeSkipped,
        useOnBillingAddress: (_r = input.tribute) === null || _r === void 0 ? void 0 : _r.useOnBillingAddress,
        embed_referer: window.location.href,
        converted_to_recurring: input.convertedToRecurring,
    };
    if (input.designations) {
        donationOptions.designations = input.designations;
    }
    else {
        donationOptions.designations = [];
    }
    if (input.designationId) {
        donationOptions.designations.push([
            {
                id: input.designationId,
                amount: input.paymentAmount,
            },
        ]);
    }
    var utmFields = {};
    if (input.utm) {
        if (input.utm.campaign) {
            utmFields.utm_campaign = input.utm.campaign;
        }
        if (input.utm.content) {
            utmFields.utm_content = input.utm.content;
        }
        if (input.utm.medium) {
            utmFields.utm_medium = input.utm.medium;
        }
        if (input.utm.source) {
            utmFields.utm_source = input.utm.source;
        }
        if (input.utm.term) {
            utmFields.utm_term = input.utm.term;
        }
    }
    [1, 2, 3, 4, 5].forEach(function (customNoteIndex) {
        var key = "custom_note_" + customNoteIndex;
        if (input.customerMeta[key]) {
            donationOptions[key] = input.customerMeta[key];
            delete input.customerMeta[key];
        }
    });
    return __assign(__assign(__assign(__assign(__assign(__assign({}, donationOptions), billingAddress), billingContact), payment), utmFields), { customer_meta: input.customerMeta, recaptcha_token: input.recaptchaToken, recaptcha_type: input.recaptchaType });
}
exports.buildCashPaymentPayload = buildCashPaymentPayload;
function buildDonationResult(response) {
    var campaign;
    var designation;
    var donor;
    var schedule;
    var transaction;
    if (response._raw_response.transaction) {
        transaction = response._raw_response.transaction;
    }
    if (response._raw_response.schedule) {
        schedule = response._raw_response.schedule;
    }
    if (response._raw_response.donor) {
        donor = response._raw_response.donor;
    }
    if (response._raw_response.designation) {
        designation = response._raw_response.designation;
    }
    if (response._raw_response.campaign) {
        campaign = response._raw_response.campaign;
    }
    return __assign(__assign({}, response), { campaign: campaign,
        designation: designation,
        donor: donor,
        schedule: schedule,
        transaction: transaction });
}
exports.buildDonationResult = buildDonationResult;
function buildCreatePaymentMethodPayload(input) {
    return {
        gateway_id: input.paymentGatewayId,
        backend_name: input.backendName,
        payment_method_type: input.paymentMethodType,
        payment_method_token: input.paymentMethodToken,
        donor_id: input.donorId,
        first_name: input.contact.firstName,
        last_name: input.contact.lastName,
        company: input.contact.company,
        email: input.contact.email,
        phone: input.contact.primaryPhone,
        country: input.address.country,
        address1: input.address.address1,
        address2: input.address.address2,
        city: input.address.city,
        state: input.address.state,
        zip_code: input.address.zip,
        recaptcha_token: input.recaptchaToken,
        recaptcha_type: input.recaptchaType,
    };
}
exports.buildCreatePaymentMethodPayload = buildCreatePaymentMethodPayload;
function collapseClientErrors(errors) {
    return new types_1.ClientError(errors.map(function (err) { return err.message; }).join('<br />'), {
        _rawPayload: errors,
    });
}
exports.collapseClientErrors = collapseClientErrors;
function buildCreatePaymentMethodResult(response) {
    return __assign(__assign({}, response), { paymentMethodId: response._raw_response.result.id });
}
exports.buildCreatePaymentMethodResult = buildCreatePaymentMethodResult;
function unpackSpreedlyResponse(response) {
    return response.json().then(function (data) {
        if (data.errors) {
            throw new types_1.ClientError(data.errors
                .map(function (spreedlyError) { return spreedlyError.message; })
                .join('<br />'), data);
        }
        return data;
    });
}
exports.unpackSpreedlyResponse = unpackSpreedlyResponse;
function extractSpreedlyToken(spreedlyData) {
    if (!spreedlyData.transaction || !spreedlyData.transaction.payment_method) {
        throw new types_1.ClientError('Payment Method not tokenized.');
    }
    return spreedlyData.transaction.payment_method.token;
}
exports.extractSpreedlyToken = extractSpreedlyToken;
